import * as React from "react";
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { Collection } from "../../../types";
import { SxProps } from "@mui/material/styles";

type Order = "asc" | "desc";

interface HeadCell {
  disablePadding: boolean;
  id: keyof Collection;
  label: string;
  numeric: boolean;
  width?: number;
  minWidth?: number;
  maxWidth?: number;
  sx?: SxProps;
  isSort?: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date",
    sx: {
      minWidth: "150px",
    },
    isSort: true,
  },
  {
    id: "displayName",
    numeric: false,
    disablePadding: false,
    label: "Display Name",
    sx: {
      minWidth: "150px",
    },
  },
  {
    id: "collectionSiteId",
    label: "Collection Site",
    numeric: false,
    disablePadding: false,
    sx: {
      minWidth: "150px",
    },
  },
  {
    label: "Collection Method",
    numeric: false,
    disablePadding: false,
    id: "trapTypeId",
    sx: {
      minWidth: "150px",
    },
  },
  {
    label: "Collection Date",
    numeric: false,
    disablePadding: false,
    id: "collectionDate",
    sx: {
      minWidth: "150px",
    },
  },
];

interface EnhancedTableProps {
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Collection
  ) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

const EnhancedTableHead = (props: EnhancedTableProps) => {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler =
    (property: keyof Collection) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        <TableCell align="center" colSpan={2}>
          {/* Country */}
        </TableCell>
        <TableCell align="center" colSpan={3}>
          Collection Details
        </TableCell>
        <TableCell align="center" colSpan={1}>
          {/* Details */}
        </TableCell>
      </TableRow>
      <TableRow>
        {headCells.map((headCell) =>
          headCell.isSort ? (
            <TableCell
              key={headCell.id}
              align={"center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={headCell.sx}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ) : (
            <TableCell
              key={headCell.id}
              align={"center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={headCell.sx}
            >
              {headCell.label}
            </TableCell>
          )
        )}
        <TableCell align="center" colSpan={1} sx={{ minWidth: "150px" }}>
          Action
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
